// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1MZjZ","calendarButtons":"ClockData_calendarButtons__39Z1W"};